import type { AttributePlugin } from '../../../engine/types'
import { modifyCasing } from '../../../utils/text'

export const Computed: AttributePlugin = {
  type: 'attribute',
  name: 'computed',
  keyReq: 'must',
  valReq: 'must',
  isExpr: true,
  onLoad: ({ key, mods, rx, root, computed }) => {
    key = modifyCasing(key, mods)
    root[key] = computed(rx)
  },
}
